const coverMap = new Map([
	['news', 'news_header.jpg'],
	['notices', 'service_notice.jpg']
]);

const ajaxMap = new Map([
	['news', 'getNews'],
	['notices', 'getNotices']
]);

export { coverMap, ajaxMap };



// WEBPACK FOOTER //
// ./src/pages/year-content/config.js